import { createContext, useContext, useEffect, useState, ReactNode } from 'react';

export interface Conf {
  REACT_APP_OKTA_ISSUER_URL?: string;
  REACT_APP_OKTA_CLIENT_ID?: string;
  REACT_APP_GED_THETRA_API_URL?: string;
  REACT_APP_ADMIN_LIST?: string;
  REACT_APP_DEPTH_FOLDER?: string;
}

const DEFAULT_CONF: Conf = {
  REACT_APP_OKTA_ISSUER_URL: '',
  REACT_APP_OKTA_CLIENT_ID: '',
  REACT_APP_GED_THETRA_API_URL: '',
  REACT_APP_ADMIN_LIST: '',
  REACT_APP_DEPTH_FOLDER: '3',
};

// Définir le type du contexte
interface ConfContextProps {
  conf: Conf;
  loading: boolean;
  error: boolean;
}

const ConfContext = createContext<ConfContextProps>({
  conf: DEFAULT_CONF,
  loading: true,
  error: false,
});

export const ConfProvider = ({ children }: { children: ReactNode }) => {
  const [conf, setConf] = useState<Conf>(DEFAULT_CONF);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const fetchConf = async () => {
    setError(false);
    try {
      const result = await fetch('/conf.json', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then((res) => res.json());      
      setLoading(false);
      setConf(result);
    } catch (error) {
      setLoading(false);
      setError(true);
      setConf(DEFAULT_CONF);
    }
  };

  useEffect(() => {
    fetchConf();
  }, []);

  return (
    <ConfContext.Provider value={{ conf, loading, error }}>
      {children}
    </ConfContext.Provider>
  );
};

export const useConf = () => useContext(ConfContext);
